// import { makeObservable, observable } from 'mobx'
import type { ScenarioService } from '@/service/scenario.service'

import { DTO } from '../DTO'

export class SubScenario extends DTO {
  id: ValueOf<(typeof ScenarioService)['scenarioIds']>
  title: string
  descHTML: string
  badgeTitle = '더 알아보고 싶어요!'
  order: number

  constructor(
    data: Pick<SubScenario, 'id' | 'title' | 'descHTML' | 'order'> & Partial<SubScenario>,
  ) {
    super()

    // 지금은 static해서 관찰 X
    // 나중에 외부데이터 이을 때 주석 풀기
    // makeObservable(this, {
    //   id: observable,
    //   title: observable,
    //   descHTML: observable,
    //   badgeTitle: observable,
    //   order: observable,
    // })

    this.id = data.id
    this.title = data.title
    this.descHTML = data.descHTML
    this.order = data.order

    if (data.badgeTitle) {
      this.badgeTitle = data.badgeTitle
    }
  }
}
